/*
  Cabora Goods — product-form.js
  Variant selection + media sync, price/inventory/URL updates, thumbnail
  gallery, sticky ATC visibility, and image zoom. Vanilla JS, `defer`.
*/
(function () {
  'use strict';

  var section = document.querySelector('[data-product-section]');
  if (!section) return;

  var variantsScript = section.parentElement.querySelector('[data-variant-json]') || document.querySelector('[data-variant-json]');
  var variants = [];
  try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }

  var form = document.querySelector('[data-product-form]');
  var variantIdInput = form ? form.querySelector('[data-variant-id]') : null;
  var addButton = form ? form.querySelector('[data-add-to-cart]') : null;
  var addButtonText = addButton ? addButton.querySelector('[data-add-to-cart-text]') : null;

  /* ---------- Variant selection ---------- */
  function getSelectedOptions() {
    var picker = document.querySelector('[data-variant-picker]');
    if (!picker) return null;
    var checked = picker.querySelectorAll('.variant-option__input:checked');
    return Array.prototype.map.call(checked, function (i) { return i.value; });
  }

  function findVariant(selected) {
    if (!selected) return variants[0];
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });
  }

  function updatePrice(variant) {
    var priceHost = document.querySelector('.product__price .price');
    if (!priceHost || !variant) return;
    var html = window.Cabora.formatMoney(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      html = '<span class="price__current">' + window.Cabora.formatMoney(variant.price) + '</span>' +
             ' <s class="price__compare">' + window.Cabora.formatMoney(variant.compare_at_price) + '</s>';
      priceHost.classList.add('price--on-sale');
    } else {
      html = '<span class="price__current">' + html + '</span>';
      priceHost.classList.remove('price--on-sale');
    }
    priceHost.innerHTML = html;
  }

  function updateButton(variant) {
    if (!addButton) return;
    if (variant && variant.available) {
      addButton.disabled = false;
      addButton.removeAttribute('aria-disabled');
      if (addButtonText) addButtonText.textContent = (window.CaboraStrings && window.CaboraStrings.addToCart) || 'Add to cart';
    } else {
      addButton.disabled = true;
      addButton.setAttribute('aria-disabled', 'true');
      if (addButtonText) addButtonText.textContent = variant ? ((window.CaboraStrings && window.CaboraStrings.soldOut) || 'Sold out') : 'Unavailable';
    }
    // Mirror to sticky bar
    var stickyBtn = document.querySelector('[data-sticky-add]');
    if (stickyBtn) {
      stickyBtn.disabled = addButton.disabled;
      stickyBtn.textContent = addButtonText ? addButtonText.textContent : stickyBtn.textContent;
    }
  }

  function updateSelectedLabels(selected) {
    document.querySelectorAll('[data-selected-value]').forEach(function (el) {
      var pos = parseInt(el.dataset.selectedValue, 10);
      if (selected && selected[pos - 1]) el.textContent = selected[pos - 1];
    });
  }

  function updateURL(variant) {
    if (!variant || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  function updateMediaForVariant(variant) {
    if (!variant || !variant.featured_media) return;
    switchMedia(String(variant.featured_media.id));
  }

  function onVariantChange() {
    var selected = getSelectedOptions();
    var variant = findVariant(selected);
    updateSelectedLabels(selected);
    if (!variant) { updateButton(null); return; }
    if (variantIdInput) variantIdInput.value = variant.id;
    updatePrice(variant);
    updateButton(variant);
    updateURL(variant);
    updateMediaForVariant(variant);
  }

  var picker = document.querySelector('[data-variant-picker]');
  if (picker) {
    picker.addEventListener('change', onVariantChange);
  }

  /* ---------- Media gallery ---------- */
  function switchMedia(mediaId) {
    document.querySelectorAll('.product__slide').forEach(function (slide) {
      var active = slide.dataset.mediaId === mediaId;
      slide.classList.toggle('is-active', active);
      if (!active) {
        var vid = slide.querySelector('video');
        if (vid) vid.pause();
      }
    });
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t.dataset.mediaId === mediaId);
    });
  }
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () { switchMedia(thumb.dataset.mediaId); });
  });

  /* ---------- Sticky ATC visibility ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var buyBlock = document.querySelector('.product__buy');
  if (stickyBar && buyBlock && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // show sticky bar when the main buy button scrolls out of view
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', String(entry.isIntersecting));
      });
    }, { rootMargin: '0px 0px -80px 0px' });
    obs.observe(buyBlock);
  }
  var stickyAdd = document.querySelector('[data-sticky-add]');
  if (stickyAdd && addButton) {
    stickyAdd.addEventListener('click', function () { addButton.click(); });
  }

  /* ---------- Image zoom ---------- */
  var lightbox = document.querySelector('[data-zoom-lightbox]');
  if (lightbox) {
    var zoomImg = lightbox.querySelector('[data-zoom-image]');
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-zoom-open]');
      if (open) { zoomImg.src = open.dataset.zoomSrc; lightbox.hidden = false; document.body.classList.add('nav-locked'); return; }
      if (e.target.closest('[data-zoom-close]') || e.target === lightbox) {
        lightbox.hidden = true; document.body.classList.remove('nav-locked'); zoomImg.src = '';
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lightbox.hidden) { lightbox.hidden = true; document.body.classList.remove('nav-locked'); }
    });
  }

  // Initialize on load
  onVariantChange();
})();
